import {GetObligationPdfParams} from 'domain/usecases';
import {makeGetObligationPdf} from 'main/factories/usecases/private/my-payments-flow/remote-my-payments/get-boleto-pdf';

export async function getObligationPdf(params: GetObligationPdfParams) {
	const response = await makeGetObligationPdf().get(params);

	return response;
}
